import { z } from "zod";

export const MultiSelectDefaultValuesSchema = z
  .array(
    z.object({
      value: z.string().uuid(),
      label: z.string(),
    }),
  )
  .optional();

export const VersionUpdateBodySchema = z.object({
  version: z.number().int().positive(),
});
